import { useTranslation } from "react-i18next"

import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

export const useBuildCertificatesSearch = () => {
  const { t } = useTranslation("certificates")

  const { search, setSearch, isLoading } = useCertificatesTableContext()

  const setSearchValue = ({ search }: { search: string }) => {
    setSearch(search)
  }

  return {
    search: { search },
    setSearch: setSearchValue,
    placeholder: t("lists.placeholders.search"),
    isLoading,
  }
}
